// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-8e8087c7] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.progress-bar[data-v-8e8087c7] {
  display: block;
  height: var(--progress-bar-height);
  --progress-bar-color: var(--efbac356);
}
.progress-bar--linear[data-v-8e8087c7] {
  width: 100%;
  overflow: hidden;
  border: 0;
  padding: 0;
  background: var(--color-background-dark);
  border-radius: calc(var(--progress-bar-height) / 2);
}
.progress-bar--linear[data-v-8e8087c7]::-webkit-progress-bar {
  height: var(--progress-bar-height);
  background-color: transparent;
}
.progress-bar--linear[data-v-8e8087c7]::-webkit-progress-value {
  background: var(--progress-bar-color, var(--gradient-primary-background));
  border-radius: calc(var(--progress-bar-height) / 2);
}
.progress-bar--linear[data-v-8e8087c7]::-moz-progress-bar {
  background: var(--progress-bar-color, var(--gradient-primary-background));
  border-radius: calc(var(--progress-bar-height) / 2);
}
.progress-bar--circular[data-v-8e8087c7] {
  width: var(--progress-bar-height);
  color: var(--progress-bar-color, var(--color-primary-element));
}
.progress-bar--error[data-v-8e8087c7] {
  color: var(--color-text-error, var(--color-error)) !important;
}
.progress-bar--error[data-v-8e8087c7]::-moz-progress-bar {
  background: var(--color-text-error, var(--color-error)) !important;
}
.progress-bar--error[data-v-8e8087c7]::-webkit-progress-value {
  background: var(--color-text-error, var(--color-error)) !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcProgressBar-DTCznR-m.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,mDAAmD;AACrD;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,yEAAyE;EACzE,mDAAmD;AACrD;AACA;EACE,yEAAyE;EACzE,mDAAmD;AACrD;AACA;EACE,iCAAiC;EACjC,8DAA8D;AAChE;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,kEAAkE;AACpE;AACA;EACE,kEAAkE;AACpE","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-8e8087c7] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.progress-bar[data-v-8e8087c7] {\n  display: block;\n  height: var(--progress-bar-height);\n  --progress-bar-color: var(--efbac356);\n}\n.progress-bar--linear[data-v-8e8087c7] {\n  width: 100%;\n  overflow: hidden;\n  border: 0;\n  padding: 0;\n  background: var(--color-background-dark);\n  border-radius: calc(var(--progress-bar-height) / 2);\n}\n.progress-bar--linear[data-v-8e8087c7]::-webkit-progress-bar {\n  height: var(--progress-bar-height);\n  background-color: transparent;\n}\n.progress-bar--linear[data-v-8e8087c7]::-webkit-progress-value {\n  background: var(--progress-bar-color, var(--gradient-primary-background));\n  border-radius: calc(var(--progress-bar-height) / 2);\n}\n.progress-bar--linear[data-v-8e8087c7]::-moz-progress-bar {\n  background: var(--progress-bar-color, var(--gradient-primary-background));\n  border-radius: calc(var(--progress-bar-height) / 2);\n}\n.progress-bar--circular[data-v-8e8087c7] {\n  width: var(--progress-bar-height);\n  color: var(--progress-bar-color, var(--color-primary-element));\n}\n.progress-bar--error[data-v-8e8087c7] {\n  color: var(--color-text-error, var(--color-error)) !important;\n}\n.progress-bar--error[data-v-8e8087c7]::-moz-progress-bar {\n  background: var(--color-text-error, var(--color-error)) !important;\n}\n.progress-bar--error[data-v-8e8087c7]::-webkit-progress-value {\n  background: var(--color-text-error, var(--color-error)) !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
